import { useEffect, useState } from "react";
import { actionsAccess } from "../../../../General/Components/ActionControlesUiAccess";
import { defaultSettings } from "../../../../utils/dashboardAccessList";
import { useDashboardSettings } from "../../../../Context/DashboardSettingProvider";

const useDashboardContainer = () => {
  const DesignerOrderRegisterCountChart = actionsAccess(
    "Dashboard",
    "GetDesignerOrderRegisterCountChart",
  );
  const OrderCountChartAccess = actionsAccess(
    "Dashboard",
    "GetOrderCountChart",
  );
  const OrderCountChartForCustomer = actionsAccess(
    "Dashboard",
    "GetOrderCountChartForCustomer",
  );
  const CustomerOrderRegisterCountChartAccess = actionsAccess(
    "Dashboard",
    "GetCustomerOrderRegisterCountChart",
  );
  const GetPlateAreaChartAccess = actionsAccess(
    "Dashboard",
    "GetPlateAreaChart",
  );
  const GetOrderCountChartForDesigner = actionsAccess(
    "Dashboard",
    "GetOrderCountChartForDesigner",
  );
  const GetAccessAvrageKlischePrice = actionsAccess(
    "Dashboard",
    "GetAvrageKlischePrice",
  );
  const GetAccessOrderCompare = actionsAccess(
    "Dashboard",
    "GetOrderCompareCountChart",
  );
  const GetAccessOrderType = actionsAccess("Dashboard", "GetOrderTypeChart");
  const GetAccessProductionPlate = actionsAccess(
    "Dashboard",
    "GetProductionPlate",
  );
  const GetHourlyOrderRegisterCountChart = actionsAccess(
    "Dashboard",
    "GetHourlyOrderRegisterCountChart",
  );
  const GetAccessPersonLeave = actionsAccess("Dashboard", "GetLeaveCounts");
  const palateDamage = actionsAccess("Dashboard", "GetPlateDamageAreaChart");
  const GetInvoicePriceChart = actionsAccess(
    "Dashboard",
    "GetInvoicePriceChart",
  );
  const DashboardBoxesVisibility = actionsAccess(
    "Dashboard",
    "DashboardBoxesVisibility",
  );
  const GetSalesExpertInvoicePriceChart = actionsAccess(
    "Dashboard",
    "GetSalesExpertInvoicePriceChart",
  );
  const GetDesignerOrderDesignHistoryChart = actionsAccess(
    "Dashboard",
    "GetDesignerOrderDesignHistoryChart",
  );
  const GetCustomerOrderDesignHistoryChart = actionsAccess(
    "Dashboard",
    "GetCustomerOrderDesignHistoryChart",
  );
  const GetOrderCountChart = actionsAccess("Dashboard", "GetOrderTypeRatio");
  const GetKlischeTypeRatio = actionsAccess("Dashboard", "GetKlischeTypeRatio");

  /* -------------------------- Access Chart setting -------------------------- */
  const { dashControlleChart } = useDashboardSettings();
  const [chartsAccess, setChartsAccess] = useState([]);

  const checkAccess = (values) => {
    if (DashboardBoxesVisibility) {
      const chartName = values.filter((item) => item.value).map((i) => i.chart);
      setChartsAccess(chartName);
    } else {
      const chartName = defaultSettings?.map((item) => item.chart);
      setChartsAccess(chartName);
    }
  };
  useEffect(() => {
    checkAccess(dashControlleChart);
  }, [dashControlleChart]);

  return {
    access: {
      DesignerOrderRegisterCountChart: DesignerOrderRegisterCountChart,
      OrderCountChartAccess: OrderCountChartAccess,
      OrderCountChartForCustomer: OrderCountChartForCustomer,
      CustomerOrderRegisterCountChartAccess:
        CustomerOrderRegisterCountChartAccess,
      GetPlateAreaChartAccess: GetPlateAreaChartAccess,
      GetPersonDesignerChart: GetOrderCountChartForDesigner,
      GetAccessAvrageKlischePrice: GetAccessAvrageKlischePrice,
      GetAccessPersonLeave: GetAccessPersonLeave,
      palateDamage: palateDamage,
      GetAccessOrderCompare: GetAccessOrderCompare,
      GetAccessOrderType: GetAccessOrderType,
      GetAccessProductionPlate: GetAccessProductionPlate,
      getInvoicePriceChart: GetInvoicePriceChart,
      getHourlyOrderRegisterCountChart: GetHourlyOrderRegisterCountChart,
      getSalesExpertInvoicePriceChart: GetSalesExpertInvoicePriceChart,
      GetDesignerOrderDesignHistoryChart: GetDesignerOrderDesignHistoryChart,
      GetCustomerOrderDesignHistoryChart: GetCustomerOrderDesignHistoryChart,
      GetOrderCountChart: GetOrderCountChart,
      GetKlischeTypeRatio: GetKlischeTypeRatio,
    },
    chartsAccess,
  };
};
export default useDashboardContainer;
